import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { with: String }; // Value for the text to display when disabled
  static targets = ["button"]; // Target for the button element

  connect() {
    if (!this.hasWithValue) {
      this.withValue = "Processing ..."; // Default text if not provided
    }
  }

  // Action to trigger on form submission or button click
  disable(event) {
    const button = this.buttonTarget
    button.value = this.withValue; // Change text
    button.disabled = true; // Disable the button
  }
}